// // // // export default function CustomerReviews() {
// // // //   const reviews = [
// // // //     {
// // // //       name: "Shriya",
// // // //       text: `I'm Happy with the product quality and ease of using it. 
// // // //       I was looking for a quality product for special days, and Confidays 
// // // //       matched all my needs — softness, hygiene, and comfort.`,
// // // //     },
// // // //     {
// // // //       name: "Madhuri",
// // // //       text: `Perfect for me. Confidays sanitary pads are simple, comfortable,
// // // //       and skin-friendly. I loved the disposal bags too. Definitely recommended.`,
// // // //     },
// // // //     {
// // // //       name: "Sunaina",
// // // //       text: `I've been using Confidays diapers for more than 3 months.
// // // //       No rashes, super absorbent, very soft. Baby happy — I'm happy!`,
// // // //     },
// // // //   ];

// // // //   return (
// // // //     <section className="w-full bg-white py-16">
// // // //       <div className="max-w-7xl mx-auto px-4">
// // // //         {/* Title */}
// // // //         <h4 className="text-2xl font-semibold text-center mb-12">
// // // //           Customer Reviews
// // // //         </h4>

// // // //         {/* Reviews */}
// // // //         <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
// // // //           {reviews.map((review, i) => (
// // // //             <div
// // // //               key={i}
// // // //               className="border rounded-xl p-6 text-center shadow-sm hover:shadow-md transition"
// // // //             >
// // // //               {/* Review Text */}
// // // //               <p className="text-gray-700 text-sm leading-relaxed mb-6">
// // // //                 “{review.text}”
// // // //               </p>

// // // //               {/* Divider */}
// // // //               <div className="w-10 h-[2px] bg-purple-500 mx-auto mb-4" />

// // // //               {/* Name */}
// // // //               <span className="block font-medium text-gray-900">
// // // //                 {review.name}
// // // //               </span>
// // // //             </div>
// // // //           ))}
// // // //         </div>
// // // //       </div>
// // // //     </section>
// // // //   );
// // // // }

// // // export default function CustomerReviews() {
// // //   const reviews = [
// // //     {
// // //       name: "Shriya",
// // //       text:
// // //         "I’m Happy with the product quality and easy of using it. I’m looking for a quality product to match my needs on special days, I think Confidays had all the things I needed. Whether its softness or quality and hygiene",
// // //     },
// // //     {
// // //       name: "Madhuri",
// // //       text:
// // //         "Perfect for Me, I really liked confidays sanitary pads as they are very simple and easy to use and comfortable pads with skin friendly materials. I was happy that it comes with disposal bags as well. Definitely I’ll recommend confidays",
// // //     },
// // //     {
// // //       name: "Sunaina",
// // //       text:
// // //         "I’ve been using Confidays diapers for more than 3 months for my Baby. They work like magic !!! No rashes – super absorbent, very soft and comfortable !!! No more crying… Baby happy !!! I’m happy !!!",
// // //     },
// // //   ];

// // //   return (
// // //     <section className="w-full bg-gray-100 py-20">
// // //       <div className="max-w-7xl mx-auto px-6">

// // //         {/* ---------- TITLE ---------- */}
// // //         <h2 className="text-2xl font-semibold text-center text-blue-800 mb-10">
// // //           Customers Reviews
// // //         </h2>

// // //         {/* ---------- REVIEWS GRID ---------- */}
// // //         <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

// // //           {reviews.map((review, index) => (
// // //             <div
// // //               key={index}
// // //               className="border border-gray-400 p-10 text-center flex flex-col justify-between min-h-[300px]"
// // //             >
// // //               {/* TEXT */}
// // //               <p className="text-sm text-gray-800 leading-relaxed">
// // //                 {review.text}
// // //               </p>

// // //               {/* NAME */}
// // //               <span className="font-semibold text-black">
// // //                 {review.name}
// // //               </span>
// // //             </div>
// // //           ))}

// // //         </div>
// // //       </div>
// // //     </section>
// // //   );
// // // }

// // export default function CustomerReviews() {
// //   const reviews = [
// //     {
// //       name: "Shriya",
// //       text:
// //         "I’m Happy with the product quality and easy of using it. I’m looking for a quality product to match my needs on special days, I think Confidays had all the things I needed. Whether its softness or quality and hygiene",
// //     },
// //     {
// //       name: "Madhuri",
// //       text:
// //         "Perfect for Me, I really liked confidays sanitary pads as they are very simple and easy to use and comfortable pads with skin friendly materials. I was happy that it comes with disposal bags as well. Definitely I’ll recommend confidays",
// //     },
// //     {
// //       name: "Sunaina",
// //       text:
// //         "I’ve been using Confidays diapers for more than 3 months for my Baby. They work like magic !!! No rashes – super absorbent, very soft and comfortable !!! No more crying… Baby happy !!! I’m happy !!!",
// //     },
// //   ];

// //   return (
// //     <section className="w-full bg-white py-2 font-poppins">
// //       <div className="max-w-7xl mx-auto px-6">

// //         {/* ---------- TITLE ---------- */}
// //         <h2 className="text-3xl md:text-4xl font-semibold text-center text-[#1F2F8F] mb-16">
// //           Customers Reviews
// //         </h2>

// //         {/* ---------- REVIEWS GRID ---------- */}
// //         <div className="grid grid-cols-1 md:grid-cols-3 gap-10 font-poppins">

// //           {reviews.map((review, index) => (
// //             <div
// //               key={index}
// //               className="border border-gray-400 rounded-md px-10 py-12 text-center flex flex-col justify-between min-h-[360px]"
// //             >
// //               {/* REVIEW TEXT */}
// //               <p className="text-[15px] text-gray-800 leading-relaxed">
// //                 {review.text}
// //               </p>

// //               {/* NAME */}
// //               <span className="mt-8 font-semibold text-black text-lg">
// //                 {review.name}
// //               </span>
// //             </div>
// //           ))}

// //         </div>
// //       </div>
// //     </section>
// //   );
// // }

// export default function CustomerReviews() {
//   const reviews = [
//     {
//       name: "Shriya",
//       text:
//         "I’m Happy with the product quality and easy of using it. I’m looking for a quality product to match my needs on special days, I think Confidays had all the things I needed. Whether its softness or quality and hygiene",
//     },
//     {
//       name: "Madhuri",
//       text:
//         "Perfect for Me, I really liked confidays sanitary pads as they are very simple and easy to use and comfortable pads with skin friendly materials. I was happy that it comes with disposal bags as well. Definitely I’ll recommend confidays",
//     },
//     {
//       name: "Sunaina",
//       text:
//         "I’ve been using Confidays diapers for more than 3 months for my Baby. They work like magic !!! No rashes – super absorbent, very soft and comfortable !!! No more crying… Baby happy !!! I’m happy !!!",
//     },
//   ];

//   return (
//     <section className="w-full bg-[#F7F8FC] py-20 font-poppins">
//       <div className="max-w-7xl mx-auto px-6">

//         {/* ---------- TITLE ---------- */}
//         <h2 className="text-3xl md:text-4xl font-semibold text-center text-[#1F2F8F] mb-16">
//           Customers Testmonials
//         </h2>

//         {/* ---------- REVIEWS GRID ---------- */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

//           {reviews.map((review, index) => (
//             <div
//               key={index}
//               className="relative bg-white rounded-2xl shadow-lg px-8 pt-14 pb-10 text-center transition-transform duration-300 hover:-translate-y-2"
//             >
//               {/* AVATAR CIRCLE */}
//               <div className="absolute -top-10 left-1/2 -translate-x-1/2">
//                 <div className="w-20 h-20 rounded-full bg-gray-200 border-4 border-white shadow-md" />
//               </div>

//               {/* REVIEW TEXT */}
//               <p className="text-[15px] text-gray-600 leading-relaxed mb-8">
//                 {review.text}
//               </p>

//               {/* NAME */}
//               <span className="block font-semibold text-gray-900 text-lg">
//                 {review.name}
//               </span>

//               {/* STARS */}
//               <div className="flex justify-center gap-1 mt-4 text-pink-500">
//                 ★ ★ ★ ★ ★
//               </div>
//             </div>
//           ))}

//         </div>
//       </div>
//     </section>
//   );
// }

import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

export default function CustomerReviews() {
  const reviews = [
    {
      name: "Shriya",
      image: "/review1.jpg",
      text: "I’m really happy with the quality and comfort. Confidays feels soft, hygienic and reliable during special days.",
    },

    {
      name: "Madhuri",
      image: "/review2.jpg",
      text: "Very comfortable and skin-friendly pads. I also loved the disposal bags included inside the pack.",
    },

    {
      name: "Sunaina",
      image: "/review3.jpg",
      text: "Super soft, highly absorbent and rash-free. Confidays products genuinely provide confidence and comfort.",
    },
  ];

  return (
    <section
      className="
        relative
        overflow-hidden
        py-16 md:py-24
        bg-gradient-to-b
        from-[#fff8fc]
        via-white
        to-[#f8fbff]
        font-poppins
      "
    >
      {/* BG BLUR EFFECTS */}

      <div
        className="
          absolute
          top-0
          left-0
          w-72
          h-72
          bg-pink-100/40
          rounded-full
          blur-3xl
        "
      />

      <div
        className="
          absolute
          bottom-0
          right-0
          w-72
          h-72
          bg-blue-100/40
          rounded-full
          blur-3xl
        "
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        {/* ================= HEADING ================= */}

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-14"
        >
          {/* TAG */}

          <div
            className="
              inline-flex
              items-center

              px-5
              py-2

              rounded-full

              bg-pink-100
              text-pink-500

              text-xs
              md:text-sm

              font-semibold
              tracking-[2px]
              uppercase

              mb-5
            "
          >
            Customer Love
          </div>

          {/* TITLE */}

          <h2
            className="
              text-[34px]
              sm:text-[42px]
              md:text-[54px]

              leading-[1.05]

              font-bold

              text-[#1A237E]

              mb-5
            "
          >
            What Women Say
            <span className="text-pink-500"> About Us</span>
          </h2>

          {/* DESC */}

          <p
            className="
              max-w-2xl
              mx-auto

              text-gray-500

              text-[15px]
              md:text-[17px]

              leading-[1.9]
            "
          >
            Thousands trust Confidays for everyday comfort, protection and
            confidence.
          </p>
        </motion.div>

        {/* ================= REVIEW GRID ================= */}

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {reviews.map((review, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 35 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.45, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="
                group
                relative

                bg-white/90
                backdrop-blur-xl

                border
                border-pink-100

                rounded-[30px]

                p-7 md:p-8

                shadow-[0_10px_40px_rgba(236,72,153,0.06)]

                transition-all
                duration-500

                hover:-translate-y-2
                hover:shadow-[0_18px_60px_rgba(236,72,153,0.12)]
              "
            >
              {/* QUOTE ICON */}

              <div
                className="
                  absolute
                  top-6
                  right-6

                  w-12
                  h-12

                  rounded-full

                  bg-pink-50

                  flex
                  items-center
                  justify-center
                "
              >
                <Quote size={22} className="text-pink-400" />
              </div>

              {/* PROFILE */}

              <div className="flex items-center gap-4 mb-6">
                <img
                  src={review.image}
                  alt={review.name}
                  className="
                    w-16
                    h-16

                    rounded-full

                    object-cover

                    border-4
                    border-white

                    shadow-md
                  "
                />

                <div>
                  <h3 className="font-semibold text-[#1A237E] text-lg">
                    {review.name}
                  </h3>

                  <div className="flex gap-1 mt-1">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        size={14}
                        className="fill-pink-400 text-pink-400"
                      />
                    ))}
                  </div>
                </div>
              </div>

              {/* REVIEW TEXT */}

              <p
                className="
                  text-gray-600

                  text-[15px]
                  md:text-[16px]

                  leading-[1.9]
                "
              >
                {review.text}
              </p>

              {/* BOTTOM LINE */}

              <div
                className="
                  mt-6

                  w-16
                  h-[3px]

                  rounded-full

                  bg-gradient-to-r
                  from-pink-400
                  to-[#1A237E]
                "
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
